<template>
    <div v-loading="loading" class="m_container">
        <form-create ref="memberSetting" v-model="fApi" :rule="memberRule" :option="option" @change="formcreateChange" />
        <ElButton v-loading="saveLoading" :disabled="isActivityEnd" type="primary" class="submitbtn" @click="submitMember">
            {{ $t('Notification.next') }}
        </ElButton>
    </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import mixin_formCreate from '@/utils/project/formCreate_mixin'
import { mapGetters } from 'vuex'
import { memberInfo } from '@/api/Tougaos'

export default {
    name: 'MemberInfo',
    mixins: [mixin_formCreate],
    props: {
        tid: {
            type: String,
            default: ''
        },
        rule: {
            type: Array,
            default() {
                return []
            }
        },
        froms: {
            type: String,
            default: ''
        },
        saveLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            ajaxData: {
                id: undefined,
                tid: this.tid,
                info: ''
            },
            memberRule: [],
            fApi: {},
            option: {
                form: {
                    inline: true,
                    labelPosition: 'right',
                    labelWidth: '100'
                },
                submitBtn: {
                    icon: 'none',
                    show: false
                }
            }
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo', 'categoryList']),
        isActivityEnd() {
            return new Date() > new Date(this.tougaoInfo.end_at)
        }
    },

    created() {
        this.getMemberInfo()
    },

    methods: {
        // radio、select change事件
        formcreateChange(e) {
            this.$refs.memberSetting?.$refs?.cForm1?.clearValidate()
            // 获取当前radio、select的下标【身份证类型 e=card_type】
            const index = this.memberRule.findIndex((item) => item.field === e)
            if (index === -1) return
            // 规则校验
            if (this.memberRule[index].props.effectRequiredField) {
                // 获取被radio、select影响的字段和下标【身份证号 id_card】
                const effect_field = this.memberRule[index].props.effectRequiredField
                const effect_field_idx = this.memberRule.findIndex((item) => item.field === effect_field)
                // 被影响字段不存在
                if (effect_field_idx === -1) return
                // 根据被影响的字段 校验规则【身份证号 id_card 校验规则】
                const validate = this.getValidatorCallBackNew(e, this.fApi)
                // 新增、删除 被影响的字段 校验规则 【新增、删除 身份证号 id_card 校验规则】
                let additional_validate_idx = -1
                if (this.memberRule[effect_field_idx].validate.length) {
                    additional_validate_idx = this.memberRule[effect_field_idx].validate.findIndex((item) => item.additional)
                }
                additional_validate_idx === -1
                    ? this.memberRule[effect_field_idx].validate.push(...validate)
                    : this.memberRule[effect_field_idx].validate.splice(additional_validate_idx, 1)
            }
            // 显示逻辑
            if (this.memberRule[index].props.effectShowField) {
                // 获取被radio、select影响的字段和下标【身份证号 id_card】
                const effect_field = this.memberRule[index].props.effectShowField
                const effect_field_idx = this.memberRule.findIndex((item) => item.field === effect_field)
                // 被影响字段不存在
                if (effect_field_idx === -1) return
                // 根据被影响的字段 显示隐藏【身份证号 id_card 显示隐藏】
                const isHidden = this.memberRule[effect_field_idx].hidden
                const effectShowVal = this.memberRule[index].props.effectShowVal
                if (this.fApi.form[e] === effectShowVal) {
                    if (isHidden) return
                    this.$set(this.memberRule[effect_field_idx], 'hidden', {
                        type: 'hidden',
                        field: this.memberRule[effect_field_idx].field
                    })
                } else {
                    isHidden ? this.$delete(this.memberRule[effect_field_idx], 'hidden') : ''
                }
            }
        },

        getMemberInfo() {
            this.loading = true
            memberInfo({ tid: this.tid }).then((res) => {
                this.loading = false
                if (res.code === 200) {
                    const { status, data } = res.data
                    if (status === 0) {
                        // 第一次进来 显示基本信息  获取基本信息
                        this.memberRule = this.resetFormRules(this.rule, {})
                    } else {
                        // 已经有基本信息了
                        EventBus.$emit('member_id', data.id)
                        this.ajaxData = data
                        if (this.froms === '/my') {
                            this.memberRule = this.resetFormRules(this.rule, data.info)
                        } else {
                            this.$emit('showMember', false)
                        }
                    }
                }
            })
        },

        submitMember() {
            if (this.isActivityEnd) return
            this.fApi.validate((v) => {
                if (!v) {
                    this.$message({
                        message: this.$t('Notification.requiredFields'),
                        type: 'warning',
                        showClose: true,
                        duration: 2000
                    })
                    return
                }
                this.fApi.submit((formData, $f) => {
                    this.ajaxData.info = formData
                })
                console.log('this.ajaxData', this.ajaxData)
                this.$emit('submit', this.ajaxData)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f5f5f5;

    .m_section {
        flex: 1;
        background: #fff;

        .submitbtn {
            width: 90%;
            margin: 20px auto 0;
        }
    }
}
</style>
